import {
	API_GET_ALL_PATIENT,
	API_GET_ALL_PATIENT_SUCCESS,
	API_GET_ALL_PATIENT_FAIL,
	API_GET_FOLDERS_PATIENT,
	API_GET_FOLDERS_PATIENT_SUCCESS,
	API_POST_PATIENT,
	API_POST_PATIENT_SUCCESS,
	API_POST_PATIENT_FAIL,
	API_SEARCH_PATIENT,
	API_SEARCH_PATIENT_SUCCESS,
	API_GET_PATIENT,
	API_GET_PATIENT_SUCCESS,
	API_GET_PATIENT_FAIL,
	API_DELETE_PATIENT,
	API_DELETE_PATIENT_FAIL,
	API_DELETE_PATIENT_SUCCESS,
	API_PATCH_PATIENT,
	API_PATCH_PATIENT_FAIL,
	API_PATCH_PATIENT_SUCCESS,
	API_SEARCH_PATIENT_FAIL,
	API_GET_PATIENT_EXISTS,
	API_GET_PATIENT_EXISTS_FAIL,
	API_GET_PATIENT_EXISTS_SUCCESS,
	API_POST_DSP_AGREEMENT,
	API_POST_DSP_AGREEMENT_SUCCESS,
	API_POST_DSP_AGREEMENT_FAIL,
	API_GET_MATCHING_PATIENT,
	API_GET_MATCHING_PATIENT_FAIL,
	API_GET_MATCHING_PATIENT_SUCCESS,
	API_GET_PATIENT_INVOICES_SUCCESS,
	API_GET_MPI_PATIENT_BY_MATRICULE,
	API_GET_MPI_PATIENT_BY_MATRICULE_SUCCESS,
	API_GET_MPI_PATIENT_BY_MATRICULE_FAIL,
	API_POST_PATIENT_DOCUMENT,
	API_POST_PATIENT_DOCUMENT_SUCCESS,
	API_POST_PATIENT_DOCUMENT_FAIL,
	API_DELETE_PATIENT_DOCUMENT,
	API_DELETE_PATIENT_DOCUMENT_FAIL,
	API_DELETE_PATIENT_DOCUMENT_SUCCESS,
	API_GET_PATIENT_DOCUMENT,
	API_GET_PATIENT_DOCUMENT_FAIL,
	API_GET_PATIENT_DOCUMENT_SUCCESS,
	API_GET_PATIENT_DKV_STATUS_SUCCESS,
	API_GET_PATIENT_DKV_STATUS,
	API_CLEAN_PATIENT_DKV_STATUS,
	API_GET_PATIENT_INVOICES_FAIL,
	API_GET_PATIENT_INVOICES,
	API_GET_PATIENT_CASING_PAYMENTS_SUCCESS,
	API_GET_PATIENT_CASING_PAYMENTS,
	API_GET_PATIENT_CASING_PAYMENTS_FAIL,
	RESET_INVOICES_FOR_PATIENT,
	API_GET_PATIENT_DKV_STATUS_FAIL,
} from "../actions/patient";
import {
	API_GET_CASING_PAYMENT_CANCEL,
	API_GET_CASING_PAYMENT_CANCEL_SUCCESS,
} from "../actions/payment";
import { toast } from "react-toastify";
import { API_POST_FOLDER_SUCCESS } from "actions/folder";
import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";
import { getVersion } from "services/patient";
import { getVersion as getPaymentVersion } from "services/payment";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

const initialState = {
	loading: false,
	search: {
		loading: false,
		list: [],
		pagination: null,
	},
	patient: null,
	dsp: {
		status: null,
		dsp_id: null,
		dsp_activation_code: null,
		dsp_agreement_uploaded: false,
	},
	documents: {},
	exists: null,
	invoices: [],
	list: [],
	errorDSP: null,
	dkvStatus: null,
	dkvSyncing: false,
	casing: {},
};

const toNumber = (value) => {
	if (value === null || value === undefined) return value;
	const num = typeof value === 'string' ? parseFloat(value) : Number(value);
	return isNaN(num) ? value : num;
};

const adaptPatientResponse = (patient, currentClient) => {
	try {
		if (!patient || currentClient !== V2_CLIENT) {
			return patient;
		}

		const adapted = { ...patient };

		const fieldMap = {
			firstName: 'first_name',
			marriedName: 'married_name',
			birthName: 'birth_name',
			emailComment: 'email_comment',
			birthDate: 'birth_date',
			homeNumber: 'home_number',
			homeStreet: 'home_street',
			homeComplement: 'home_complement',
			homeCountry: 'home_country',
			homeCity: 'home_city',
			homePostalCode: 'home_postal_code',
			workNumber: 'work_number',
			workStreet: 'work_street',
			workComplement: 'work_complement',
			workCountry: 'work_country',
			workCity: 'work_city',
			workPostalCode: 'work_postal_code',
			workCompany: 'work_company',
			phoneComment: 'phone_comment',
			mobilePhone: 'mobile_phone',
			mobilePhoneComment: 'mobile_phone_comment',
			mobilePhoneIsRelative: 'mobile_phone_is_relative',
			faxComment: 'fax_comment',
			postIt: 'post_it',
			callCenterComment: 'callCenter_comment',
			lastUpdatePostIt: 'last_update_post_it',
			createdAt: 'created_at',
			updatedAt: 'updated_at',
			silId: 'sil_id',
			providerId: 'provider_id',
			mylabIsActive: 'mylab_is_active',
			dspStatus: 'dsp_status',
			dspId: 'dsp_id',
			dspAgreementFilePath: 'dsp_agreement_file_path',
			emailCheck: 'email_check',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.providerId !== undefined && adapted.providerId !== null && adapted.provider_id === undefined) {
			adapted.provider_id = toNumber(adapted.providerId);
		}

		if (adapted.externalIds && Array.isArray(adapted.externalIds)) {
			adapted.external_ids = adapted.externalIds.map((extId) => {
				const adaptedExtId = { ...extId };
				if (adaptedExtId.patientId !== undefined && adaptedExtId.patientId !== null && adaptedExtId.patient_id === undefined) {
					adaptedExtId.patient_id = toNumber(adaptedExtId.patientId);
				}
				if (adaptedExtId.serviceId !== undefined && adaptedExtId.serviceId !== null && adaptedExtId.service_id === undefined) {
					adaptedExtId.service_id = toNumber(adaptedExtId.serviceId);
				}
				return adaptedExtId;
			});
		}

		if (adapted.patientInsurances && Array.isArray(adapted.patientInsurances)) {
			adapted.patient_insurances = adapted.patientInsurances.map((insurance) => {
				const adaptedInsurance = { ...insurance };
				if (adaptedInsurance.patientId !== undefined && adaptedInsurance.patientId !== null && adaptedInsurance.patient_id === undefined) {
					adaptedInsurance.patient_id = toNumber(adaptedInsurance.patientId);
				}
				if (adaptedInsurance.insuranceId !== undefined && adaptedInsurance.insuranceId !== null && adaptedInsurance.insurance_id === undefined) {
					adaptedInsurance.insurance_id = toNumber(adaptedInsurance.insuranceId);
				}
				return adaptedInsurance;
			});
		}

		if (adapted.languages && Array.isArray(adapted.languages)) {
			adapted.languages = adapted.languages.map((lang) => {
				const adaptedLang = { ...lang };
				if (adaptedLang.patientId !== undefined && adaptedLang.patientId !== null && adaptedLang.patient_id === undefined) {
					adaptedLang.patient_id = toNumber(adaptedLang.patientId);
				}
				return adaptedLang;
			});
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptPatientResponse:', error);
		return patient;
	}
};

const adaptPatientPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptPatientResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				if (data.results && Array.isArray(data.results)) {
					const adaptedResults = data.results.map((item) => adaptPatientResponse(item, currentClient));
					return {
						...payload,
						data: {
							...data,
							results: adaptedResults,
						},
					};
				} else if (data.items && Array.isArray(data.items)) {
					const adaptedItems = data.items.map((item) => adaptPatientResponse(item, currentClient));
					return {
						...payload,
						data: {
							...data,
							items: adaptedItems,
						},
					};
				} else {
					const adaptedData = adaptPatientResponse(data, currentClient);
					return {
						...payload,
						data: adaptedData,
					};
				}
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptPatientPayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptPaymentPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getPaymentVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (data.payments && Array.isArray(data.payments)) {
				const adaptedPayments = data.payments.map((payment) => {
					const adapted = { ...payment };
					const fieldMap = {
						transactionId: 'transaction_id',
						invoiceReference: 'invoice_reference',
						prescriptionId: 'prescription_id',
						reasonInvoice: 'reason_invoice',
						reasonInvoiceComment: 'reason_invoice_comment',
						voucherCode: 'voucher_code',
						createdAt: 'created_at',
					};
					Object.keys(fieldMap).forEach((camelKey) => {
						if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
							adapted[fieldMap[camelKey]] = adapted[camelKey];
						}
					});
					return adapted;
				});
				return {
					...payload,
					data: {
						...data,
						payments: adaptedPayments,
					},
				};
			} else if (typeof data === 'object' && data !== null) {
				return {
					...payload,
					data: data,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptPaymentPayloadResponse:', error);
		return action.payload || {};
	}
};

const patients = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_PATIENT]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_PATIENT_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPatientPayloadResponse(action, API_GET_ALL_PATIENT);
		state.list = adaptedPayload.data || [];
	},

	/** POST **/
	[API_POST_PATIENT]: (state, action) => {
		state.loading = true;
	},
	[API_POST_PATIENT_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.CREATE, action.error);
		state.loading = false;
	},
	[API_POST_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPatientPayloadResponse(action, API_POST_PATIENT);
		if (adaptedPayload.data) {
			const adaptedPatient = adaptPatientResponse(adaptedPayload.data, action.meta?.previousAction?.payload?.client || getVersion(API_POST_PATIENT).currentClient);
			const index = state.list.findIndex((p) => p.id === adaptedPatient.id);
			if (index >= 0) {
				state.list[index] = adaptedPatient;
			} else {
				state.list.push(adaptedPatient);
			}
		}
	},

	/** PATCH **/
	[API_PATCH_PATIENT]: (state, action) => {
		state.loading = true;
	},
	[API_PATCH_PATIENT_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.UPDATE, action.error);
		state.loading = false;
	},
	[API_PATCH_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPatientPayloadResponse(action, API_PATCH_PATIENT);
		if (adaptedPayload.data) {
			const currentClient = action.meta?.previousAction?.payload?.client || getVersion(API_PATCH_PATIENT).currentClient;
			const adaptedPatient = adaptPatientResponse(adaptedPayload.data, currentClient);
			const index = state.list.findIndex((i) => i.id === adaptedPatient.id);
			if (index >= 0) {
				state.list[index] = {
					...adaptedPatient,
					folders: state.list[index].folders,
				};
			}
		}
	},

	/** DELETE **/
	[API_DELETE_PATIENT]: (state, action) => {
		state.loading = true;
	},
	[API_DELETE_PATIENT_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.DELETE, action.error);
		state.loading = false;
	},
	[API_DELETE_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		/*state.list.splice(
			state.list.findIndex(i => i.id === action.meta.previousAction.payload.id),
			1
		);*/
	},

	/** GET PATIENT FOLDERS **/
	[API_GET_FOLDERS_PATIENT]: (state, action) => {},

	[API_GET_FOLDERS_PATIENT_SUCCESS]: (state, action) => {
		let index = state.list.findIndex((elt) => action.meta.previousAction.payload.id === elt.id);
		state.list[index].folders = action.payload.data;
	},

	[API_POST_FOLDER_SUCCESS]: (state, action) => {
		const patientIndex = state.list.findIndex((patient) => patient.id === action.payload.data.patient);
		if (patientIndex >= 0) state.list[patientIndex].folders.push(action.payload.data);
	},

	/** SEARCH PATIENTS **/
	[API_SEARCH_PATIENT]: (state, action) => {
		state.search.loading = true;
		state.search.list = [];
		state.search.pagination = null;
	},
	[API_SEARCH_PATIENT_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.READ, action.error);
		state.search.loading = false;
		state.search.list = [];
		state.search.pagination = null;
	},
	[API_SEARCH_PATIENT_SUCCESS]: (state, action) => {
		if (action.payload) {
			state.search.loading = false;
			const adaptedPayload = adaptPatientPayloadResponse(action, API_SEARCH_PATIENT);
			if (adaptedPayload.data) {
				state.search.list = adaptedPayload.data.results || adaptedPayload.data.items || adaptedPayload.data || [];
				state.search.pagination = adaptedPayload.data.pagination || adaptedPayload.data.meta || null;
				state.search.larger = adaptedPayload.data.larger;
			}
		}
	},

	/** PATIENT EXISTS **/
	[API_GET_PATIENT_EXISTS]: (state, action) => {
		state.loading = true;
		state.exists = null;
	},
	[API_GET_PATIENT_EXISTS_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.READ, action.error);
		state.loading = false;
		state.exists = null;
	},
	[API_GET_PATIENT_EXISTS_SUCCESS]: (state, action) => {
		state.loading = false;
		state.exists = action.payload.data.exists;
	},

	/** GET PATIENT **/
	[API_GET_PATIENT]: (state, action) => {
		state.loading = true;
		state.patient = null;
	},
	[API_GET_PATIENT_FAIL]: (state, action) => {
		state.loading = false;
		state.patient = null;
	},
	[API_GET_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPatientPayloadResponse(action, API_GET_PATIENT);
		if (adaptedPayload.data) {
			const currentClient = action.meta?.previousAction?.payload?.client || getVersion(API_GET_PATIENT).currentClient;
			state.patient = adaptPatientResponse(adaptedPayload.data, currentClient);
		}
	},

	/** POST PATIENT DSP AGREEMENT **/
	[API_POST_DSP_AGREEMENT]: (state, action) => {
		state.dsp.dsp_agreement_uploaded = false;
	},
	[API_POST_DSP_AGREEMENT_FAIL]: (state, action) => {
		state.dsp.dsp_agreement_uploaded = false;
	},
	[API_POST_DSP_AGREEMENT_SUCCESS]: (state, action) => {
		state.dsp.dsp_agreement_uploaded = true;
	},

	/** PATIENT MATCHER **/
	[API_GET_MATCHING_PATIENT]: (state, action) => {
		state.loading = true;
		state.exists = null;
	},
	[API_GET_MATCHING_PATIENT_FAIL]: (state, action) => {
		// toast.warn('Impossible de trouver une patient similaire');
		state.loading = false;
		state.exists = null;
	},
	[API_GET_MATCHING_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPatientPayloadResponse(action, API_GET_MATCHING_PATIENT);
		state.exists = adaptedPayload.data;
	},

	[API_GET_PATIENT_CASING_PAYMENTS]: (state, action) => {
		state.casing = {};
	},

	[API_GET_PATIENT_CASING_PAYMENTS_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptPaymentPayloadResponse(action, API_GET_PATIENT_CASING_PAYMENTS);
		state.casing = adaptedPayload.data || {};
	},
	[API_GET_PATIENT_CASING_PAYMENTS_FAIL]: (state, action) => {
		state.casing = {};
	},
	[API_GET_CASING_PAYMENT_CANCEL_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptPaymentPayloadResponse(action, API_GET_CASING_PAYMENT_CANCEL);
		state.casing = adaptedPayload.data || {};
	},

	[API_GET_PATIENT_INVOICES_SUCCESS]: (state, action) => {
		state.invoices = action.payload.data;
	},
	[API_GET_PATIENT_INVOICES]: (state, action) => {
		state.invoices = [];
	},
	[API_GET_PATIENT_INVOICES_FAIL]: (state, action) => {
		toast.warn("Impossible de vérifier les anciennes factures de ce patient.");
		state.invoices = [];
	},
	[RESET_INVOICES_FOR_PATIENT]: (state, action) => {
		state.invoices = [];
	},

	/** GET MPI PATIENT BY MATRICULE **/
	[API_GET_MPI_PATIENT_BY_MATRICULE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_MPI_PATIENT_BY_MATRICULE_FAIL]: (state, action) => {
		state.loading = false;
	},
	[API_GET_MPI_PATIENT_BY_MATRICULE_SUCCESS]: (state, action) => {
		state.loading = false;
	},

	/** PATIENT DOCUMENTS **/
	[API_GET_PATIENT_DOCUMENT]: (state, action) => {
		state.loading = true;
	},
	[API_GET_PATIENT_DOCUMENT_FAIL]: (state, action) => {
		state.loading = false;
		state.documents = [];
		errorHandler("Document patient", ErrorAction.READ, action.error);
	},
	[API_GET_PATIENT_DOCUMENT_SUCCESS]: (state, action) => {
		state.loading = false;
		state.documents = action.payload.data;
	},

	[API_POST_PATIENT_DOCUMENT]: (state, action) => {
		state.loading = true;
	},
	[API_POST_PATIENT_DOCUMENT_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Document patient", ErrorAction.CREATE, action.error);
	},
	[API_POST_PATIENT_DOCUMENT_SUCCESS]: (state, action) => {
		state.loading = false;
		state.documents.push(action.payload.data);
		toast.success("Document ajouté");
	},

	[API_DELETE_PATIENT_DOCUMENT]: (state, action) => {
		state.loading = true;
	},
	[API_DELETE_PATIENT_DOCUMENT_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Document patient", ErrorAction.DELETE, action.error);
	},
	[API_DELETE_PATIENT_DOCUMENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const index = state.documents.findIndex((doc) => doc.filename === action.payload.data.filename);
		if (index > -1) {
			state.documents.splice(index, 1);
		}
		toast.success("Document supprimé");
	},
	[API_GET_PATIENT_DKV_STATUS_SUCCESS]: (state, action) => {
		if (action.payload.data && !action.payload.data.error) state.dkvStatus = action.payload.data;
		state.dkvSyncing = false;
	},
	[API_GET_PATIENT_DKV_STATUS]: (state, action) => {
		state.dkvStatus = null;
		state.dkvSyncing = true;
	},
	[API_GET_PATIENT_DKV_STATUS_FAIL]: (state, action) => {
		state.dkvStatus = null;
		state.dkvSyncing = false;
	},
	[API_CLEAN_PATIENT_DKV_STATUS]: (state, action) => {
		state.dkvStatus = null;
		state.dkvSyncing = false;
	},
});

export default patients;
